import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from "../api/index"

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login'),
  },
  {
    path: '',
    component: () => import('../views/MgrMain'),
    alias: '/MgrMain',
    meta: {
      requireAuth: true
    },
    children: [{
      //后台主页
      path: '',
      component: () => import('../views/Home'),
      name: "home",
      alias: '/home'
    },
      // {
      //     //文章管理
      //     path: '/ArticleManager',
      //     name: 'ArticleManager',
      //     component: () => import('../views/article/ArticleManager')
      // },
      // {
      //     //添加文章
      //     path: '/addArticle',
      //     name: 'addArticle',
      //     component: () => import('../views/article/AddArticle')
      // },
      // {
      //     //修改文章页面
      //     path: '/changeArticle',
      //     name: 'changeArticle',
      //     component: () => import('../views/article/ChangeArticle')
      // },
      // {
      //     //账号管理
      //     path: '/accountManagement',
      //     name: 'accountManagement',
      //     component: () => import('../views/account/AccountManagement')
      // },
      // {
      //     //账号管理
      //     path: '/roleManager',
      //     name: 'roleManager',
      //     component: () => import('../views/role/RoleManager')
      // },
    ]
  }
]

let router = new VueRouter({
  mode: 'history',
  base: "/mgr/" ,
  routes
});


export let getRouter; //用来获取后台拿到的路由

// eslint-disable-next-line no-unused-vars
router.beforeEach((to, from, next) => {
  if (to.path==="/login"){
    //判断getRouter是否为空 不为空设置为空
    if(getRouter){
      getRouter = null;
    }
    //如果是登录直接放行
    next();//执行路由跳转方法
  }

  if (!getRouter) {//不加这个判断，路由会陷入死循环
    if (!getObjArr('router')) {
      axios.getUserLimit().then(res => {
        //如果返回来的不是空的
        if (res.data.userLimit!=null){
          getRouter = res.data.userLimit;
          saveObjArr('router', getRouter) //存储路由到localStorage
          routerGo(to, next)//执行路由跳转方法
        }
      })
    } else {//从localStorage拿到了路由
      getRouter = getObjArr('router')//拿到路由
      routerGo(to, next)
    }
  } else {
    next()
  }
});

function routerGo(to, next) {
  //子路由数组
  let childrenRoutes = [];
  for (let i = 0; i < getRouter.length; i++) {
    childrenRoutes.push({
      path: getRouter[i].limitSrc,
      name: getRouter[i].limitSrc,
      component: () => import(`../views${getRouter[i].limitComponent}`)
    })
  }
  //添加路由
  let routerList = [
    {
      path: '',
      component: () => import('../views/MgrMain'),
      alias: '/MgrMain',
      meta: {
        requireAuth: true
      },
      children: childrenRoutes
    }];
  router.addRoutes(routerList);
  next({...to, replace: true})
}

function saveObjArr(name, data) { //localStorage 存储数组对象的方法
  localStorage.setItem(name, JSON.stringify(data))
}

function getObjArr(name) { //localStorage
  if (window.localStorage.getItem(name)==="undefined"){
    return null;
  }
  // 获取数组对象的方法
  return JSON.parse(window.localStorage.getItem(name));
}

export default router
